import angular from 'angular';
import { fileDuplicatesModalComponent } from './fileDuplicatesModalComponent';
import 'components/sharpr/modal/modalModule';
import 'components/sharpr/date/dateFormat/dateFormatModule';

angular
	.module('sh.fileDuplicatesModal', ['sh.modal', 'sh.dateFormat'])
	.component('shFileDuplicatesModal', fileDuplicatesModalComponent());
